export default {
      id: "ic_fast_deposit_cancel_info-usage",
      viewBox: "0 0 36 36",
      url: "/" + "images/icons.3.109.2.svg#ic_fast_deposit_cancel_info-usage",
      toString: function () {
        return this.url;
      }
    }